<template>
  <div id="ComponentList" class="page message-list-page">
    <!-- 文件 -->
    <div class="search-container">
      <div>
        <span class="mg-rt-md ft-16">设计文件列表</span>
        <div v-show="activeSearchName">"{{ activeSearchName }}"中的搜索结果：</div>
        <el-breadcrumb separator="/" v-show="!activeSearchName && filePaths.length > 1">
          <el-breadcrumb-item v-show="filePaths.length">
            <span @click.stop="goBackFolder" class="return-to-upper-level">
              <i class="iconfont icon-gongnenglei_fanhui" alt=""/>
              <span>返回上一级</span>
            </span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-for="item in filePaths" :key="item.id" :title="item.name">{{ truncatedFilePaths(item.name, 8) }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-line">
        <div>
          <el-input
            v-model="searchForm.keyword"
            class="keyword-input"
            clearable
            placeholder="搜索名称"
            @change="()=>handleSearch()"
          >
            <i slot="append" class="el-icon-search" />
          </el-input>
        </div>
        <div class="btn-right">
          <span>共 {{ dataTotal }} 个内容</span>
          <el-button
              type="text"
              icon="el-icon-refresh-right"
              title="刷新"
              class="refresh-btn"
              @click.stop="handleRefresh"
          />
        </div>
      </div>
    </div>
    <div class="content-container">
      <div class="flex-1">
        <gjw-list-page-layout>
          <template #leftBox>
            <div class="folder-catalog">
              <ClassifyTreeV2
              TYPE="FILE"
              ref="classifyTree"
              :tree-data="fileTreeList"
              :list-data.sync="tableData"
              :customIcon="true"
              :expandOnClickNode="true"
              :editable="false"
              :expanded-keys="defaultKeyArr"
              @tree-node-click="treeNodeClick"
              @node-expand="treeNodeExpand"
              @node-collapse="treeNodeCollapse"
              @handleRename="updateAllData"
              @updateListData="updateAllData"
            />
            </div>
          </template>
          <template #tableBox>
            <gjw-table
              ref="listTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :list-data="selectTableData"
              :has-page="false"
              @cell-mouse-enter="showOpenButton"
              @cell-mouse-leave="hideOpenButton"
              @sort-change="sortChange"
              @row-dblclick="openFile"
            >
              <template #nameSlot="{ row }">
                <div class="table-name">
                  <div class="file-name">
                    <img v-if="row.isFolder" class="iconfont icon-wenjianjia-gongkai folder-img" src="~@/assets/img/wenjianjia.png" alt="" style="margin-right: 6px;" />
                    <img v-else class="file-img" :src="getFileIcon(row.suffix)" alt="" style="margin-right: 6px;" />
                    <span v-html="row.displayName"></span>
                  </div>
                  <el-button
                      v-show="canUpdateCachePath && !row.isFolder && showOpenFile && hoverRowId === row.id"
                      class="file-btn"
                      type="text"
                      @click="openFolder(row)"
                  >打开存储位置</el-button>
                  <el-button
                      v-show="!row.isFolder && showOpenFile && hoverRowId === row.id"
                      class="file-btn"
                      type="primary"
                      @click="openFile(row)"
                  >打开文件</el-button>
                </div>
              </template>
              <template #pathSlot="{row}">
                <div @click.stop @dbclick.stop>
                  <a class="full-file-paths"  @click.stop="goToFolder(row)">{{ row.isFolder ? '/' : '定位到所在文件夹' }}</a>
                </div>
              </template>
              <template #lengthSlot="{ row }">
                <span>{{ row.length ? formatSize(row.length, 1) : '--' }} </span>
              </template>
            </gjw-table>
          </template>
        </gjw-list-page-layout>
<!--        打开文件提示提示框-->
        <el-dialog
            :visible="showOpenDialog"
            custom-class="no-header open-file-dialog"
            width="380px"
            append-to-body
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            :destroy-on-close="true"
        >
          <div v-if="currentStep !== 2" class="tip-container">
            <div class="line-1">打开文件</div>
            <div class="line-2">
              <div v-if="currentStep === 3" style="padding: 6px 0;">
                <el-progress type="circle" :width="84" :percentage="loadPercentage"></el-progress>
              </div>
              <img v-else class="loading-img" src="../../assets/img/loading-spin.svg" />
            </div>
            <div class="line-3">
              <span v-if="currentStep === 1">{{`（1/3）正在获取“${openFileInfo.fullName}”`}}</span>
              <span v-else-if="currentStep === 3">{{`（2/3）正在下载“${openFileInfo.fullName}”`}}</span>
              <span v-else-if="currentStep === 4">（3/3）正在唤起打开程序</span>
            </div>
            <div class="line-4">请勿关闭窗口</div>
          </div>
          <div v-else class="confirm-container">
            <div class="confirm-text">
              <i class="el-icon-warning ft-18 ft-theme mg-rt-md" />
              <span>发现本地缓存与云端版本不一致，请选择操作：</span>
            </div>
            <div class="confirm-btn">
              <el-button plain @click.stop="openWebFile">打开云端版本</el-button>
              <el-button plain @click.stop="openLocal">打开本地缓存</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Utils from '@/core/utils'
import Tools from '@/core/tools'
import { businessPath, businessBasePath } from '@/core/desktopCache'
import { downloadErrorCodeMap, listErrorCodeMap } from '../file/errorCodeMap'
import ClassifyTreeV2 from '@/components/business/resource/ClassifyTreeV2.vue'

export default {
  name: 'FileList',
  props: {
    prop: {
      type: Object,
    },
    activeName: {
      type: String,
    },
  },
  components: {
    ClassifyTreeV2,
  },
  data() {
    return {
      filePaths: [],
      resourceType: 'FILE',
      searchForm: {},
      tableData: [],
      folderData: [],
      selectTableData: [],
      isFirstChange: true, // 标记selectTableData是否为第一次变化
      tableLoading: false,
      dataTotal: 0,
      spaceId: this.$route.params.spaceId,
      spaceCategoryId: null,
      fileTreeList: [],
      selectFolderId: '',
      activeSearchName: '',
      activePermissionType: '',
      defaultKeyArr: [],
      showOpenFile: false,
      hoverRowId: '',
      openFileInfo: {},
      openFilePath: '',
      zipFolderPath: '',
      showOpenDialog: false,
      // 下载进度值
      loadPercentage: 0,
      // 打开文件的当前步骤数，总共4步(第二步为是否弹出确认框)
      currentStep: 1,
    }
  },
  watch: {
    'searchForm.keyword': function(val) {
      if (!val) {
        this.quitSearchStatus()
      }
    },
  },
  computed: {
    ...mapGetters({
      spacePlatClassify: 'classifySpace/spacePlatClassify',
      user: 'user/user',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      pluginCachePath: 'pluginCachePath',
      canUpdateCachePath: 'canUpdateCachePath',
    }),
    tableColumns() {
      const allCols = [
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          sortable: 'custom',
        },
        {
          type: 'slot',
          slotName: 'pathSlot',
          label: '存储路径',
          prop: 'path',
          width: '160px',
          showFn: () => {
            return !!this.activeSearchName && this.searchForm.keyword
          }
        },
        {
          label: '创建时间',
          prop: 'createTime',
          sortable: 'custom',
          width: '140px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新时间',
          prop: 'lastModifiedTime',
          sortable: 'custom',
          width: '140px',
          formatter: (row, col, cell) => {
            return this.$fmtTime(cell, 'YYYY-MM-DD HH:mm:ss')
          },
        },
        {
          label: '更新人',
          prop: 'lastModifierName',
          width: '110px'
        },
        {
          type: 'slot',
          slotName: 'lengthSlot',
          label: '大小',
          prop: 'length',
          width: '80px'
        },
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    },
    uploaderFileTableColumns() {
      return {
        appName: true,
        validation: true
      }
    },
    truncatedFilePaths() {
      return (name, maxLength) => {
        return Utils.truncateString(name, maxLength)
      }
    },
    fullFilePaths() {
      const names = this.filePaths.map((item) => item.name)
      names.unshift('全部文件')
      return names.join('/')
    },
    formatSize() {
      return (sizeBytes, toFixed) => Tools.fmtSize(sizeBytes, toFixed)
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    },
    softwareFileType() {
      const softwareCode = this.softwareCode
      const typeObj = {
        AppGarch: ['GAP'],
        AppGstr: ['GST'],
        AppGmep: ['GMEP'],
        AppGbr: ['GMC'],
        AppGroad: ['数维道路'],
      }
      return typeObj[softwareCode]
    },
  },
  async created() {
    // 获取空间ID
    this.init()
    this.selectFolderId = this.fileTreeList[0]?.id
    this.spaceCategoryId = this.fileTreeList[0]?.id
  },
  methods: {
    async init() {
      await this.getFolderData()
      this.selectFolderId = this.fileTreeList[0]?.id
      await this.getList({ parentId: this.fileTreeList[0]?.id })
    },
    // 鼠标移入显示打开文件按钮
    showOpenButton(row) {
      this.showOpenFile = true
      this.hoverRowId = row.id
    },
    // 鼠标移出隐藏打开文件按钮
    hideOpenButton() {
      this.showOpenFile = false
      this.hoverRowId = ''
    },
    async treeNodeClick(node) {
      this.isFirstChange = true
      this.activePermissionType = node.permissionType
      this.selectFolderId = node.id
      !this.defaultKeyArr.includes(node.id) && this.defaultKeyArr.push(node.id)
      this.updateHighlightNode(this.selectFolderId)
      this.getFilePath(node)
      this.resetSelectedClassify()
      await this.quitSearchStatus()
      this.spaceCategoryId = node.id
    },
    async treeNodeExpand(node) {
      await this.treeNodeClick(node)
    },
    treeNodeCollapse(node) {
      if (this.defaultKeyArr.includes(node.id)) {
        this.defaultKeyArr = this.defaultKeyArr.filter((item) => item !== node.id)
      }
    },
    async goBackFolder() {
      this.isFirstChange = true
      // 获取上一层级
      const upOneLevel = this.getLevelFile(2)
      if (upOneLevel) {
        this.selectFolderId = upOneLevel?.id
        this.updateHighlightNode(this.selectFolderId)
        this.getFilePath(upOneLevel)
        this.getList({ parentId: upOneLevel?.id })
        return
      }
      this.filePaths = []
      await this.quitSearchStatus()
    },
    getLevelFile (level) {
      return this.filePaths[this.filePaths.length - level] || this.fileTreeList[0]
    },
    getFilePath(node) {
      const activePath = node.path.split(',').map(Number)
      // 使用 reduce 方法来构建从根到当前节点的路径
      const filePath = activePath.reduce((acc, id) => {
        const item = this.folderData.find((item) => item.id === id)
        if (item) {
          acc.push(item)
        }
        return acc
      }, [])
      this.filePaths = filePath
      return filePath.map((item) => item.name).join('/')
    },
    resetSelectedClassify() {
      this.softwareCategoryCode = null
      this.spaceCategoryId = null
    },
    sortChange(sortObj) {
      const { order, prop } = sortObj
      const propMap = {
        name: 'NAME',
        createTime: 'CREATE_TIME',
        lastModifiedTime: 'UPDATE_TIME',
        fileType: 'FILE_TYPE'
      }
      const orderMap = {
        ascending: 'ASC',
        descending: 'DESC'
      }
      const params = {
        orderBy: propMap[prop],
        orderType: orderMap[order]
      }
      this.search(params)
    },
    async openFolder(row) {
      // 埋点
      this.$tracks({
        event: 'openSpaceProfileLocalPosition',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: row.id,
        }
      })
      try {
        const res = await this.$api.file.getVersionRecords(this.spaceId, row.id)
        if (res) {
          if (row.suffix === '数维道路') {
            const folderPath = `${this.pluginCachePath}\\${this.user.strId}\\Files\\download\\${row.id}\\${row.name}`
            const { data } = await this.$desktopClient.ExistDirectory(folderPath)
            if (data) {
              await this.$desktopClient.RevealInExplorer(folderPath)
            } else {
              this.$message.error('无缓存文件')
            }
          } else {
            const filePath = `${this.pluginCachePath}\\${this.user.strId}\\Files\\download\\${row.id}\\${row.name}.${row.suffix}`
            const { data } = await this.$desktopClient.ExistFile(filePath)
            if (data) {
              await this.$desktopClient.RevealInExplorer(filePath)
            } else {
              this.$message.error('无缓存文件')
            }
          }
        }
      } catch (e) {
        this.$message.error('无缓存文件')
      }
    },
    async openFile(row) {
      this.isFirstChange = true
      if (row.isFolder) {
        this.searchForm = {}
        this.activeSearchName = ''
        this.selectFolderId = row.id
        this.spaceCategoryId = row.id
        !this.defaultKeyArr.includes(row.id) && this.defaultKeyArr.push(row.id)
        this.updateHighlightNode(this.selectFolderId)
        this.getList({ parentId: row.id })
        this.getFilePath(row)
      } else {
        if (this.canUpdateCachePath) {
          // 校正缓存路径
          await this.$desktopClient.RectifyJunction(businessBasePath(), this.pluginCachePath)
          await this.startOpenFile(row)
        } else {
          await this.startOpenFile(row)
        }
      }
    },
    async startOpenFile(row) {
      // 打开文件-判断文件是否存在，并获取启用版本的文件MD5
      const res = await this.$api.file.getVersionRecords(this.spaceId, row.id)
      if (res) {
        this.openFileInfo = row
        this.openFileInfo.fullName = row.suffix === '数维道路' ? row.name : `${row.name}.${row.suffix}`
        this.loadPercentage = 0
        const revisionRecords = res.revisionRecords || []
        const visionObj = revisionRecords.find((item) => item.status) || {}
        const continueFlag = !visionObj.softwareVersion || visionObj.softwareVersion <= this.softwareVersion
        if (continueFlag) {
          this.openFileInfo.md5 = visionObj.md5
          try {
            // 打开插件标题栏蒙层
            await this.$desktopClient.ShowMask({ region: 'R_TITLE_BAR' })
            const cachePath = await businessPath(this.user.strId)
            this.openFilePath = row.suffix === '数维道路' ? `${cachePath}\\download\\${row.id}\\${row.name}.zip` : `${cachePath}\\download\\${row.id}\\${row.name}.${row.suffix}`
            this.zipFolderPath = row.suffix === '数维道路' ? `${cachePath}\\download\\${row.id}\\${row.name}` : ''
            this.showOpenDialog = true
            this.currentStep = 1
            // 埋点
            this.$tracks({
              event: 'openSpaceProfile',
              params: {
                g_c_space_id: this.spaceId,
                g_c_file_id: row.id,
              }
            })
            await this.beforeDownload()
          } catch (err) {
            await this.$desktopClient.HideMask({ region: 'R_TITLE_BAR' })
          }
        } else {
          this.$confirm('软件版本过低，请使用高版本软件打开', {
            cancelButtonText: '确定',
            showConfirmButton: false,
            showClose: false,
            type: 'error',
          }).then().catch()
        }
      }
    },
    async beforeDownload() {
      // 判断本地是否有文件缓存
      const { data } = await this.$desktopClient.ExistFile(this.openFilePath)
      if (data) {
        // 获取文件的md5,看是否一致
        const { data: localMd5 } = await this.$desktopClient.GetFileMd5(this.openFilePath)
        if (localMd5 && localMd5 === this.openFileInfo.md5) {
          if (this.zipFolderPath) {
            // zip包需要再判断是否有同名文件夹，若有，则直接打开，如没有，则需删除同名zip文件，重新下载
            const { data: isFolderExist } = await this.$desktopClient.ExistDirectory(this.zipFolderPath)
            if (isFolderExist) {
              // 跳过下载，直接打开本地缓存文件
              await this.openLocalFile()
            } else {
              // 解压zip包，并打开本地文件
              await this.decompressOpenZip()
            }
          } else {
            // 跳过下载，直接打开本地缓存文件
            await this.openLocalFile()
          }
        } else {
          // 弹出询问框
          this.currentStep = 2
        }
      } else {
        await this.openWebFile()
      }
    },

    // 解压zip包并打开
    async decompressOpenZip() {
      const { code } = await this.$desktopClient.ExtractZipToDirectory({
        srcZipFilePath: this.openFilePath,
        destDirPath: this.zipFolderPath
      })
      if (code === 'success') {
        await this.openLocalFile()
      }
    },
    // 打开云端文件，需要下载文件
    async openWebFile() {
      this.currentStep = 3
      // 开始假的进度条
      const that = this
      const processTimer = setInterval(() => {
        if (that.loadPercentage <= 94) {
          that.loadPercentage += Tools.getRandomInt(1, 5)
        } else if (that.loadPercentage < 99) {
          that.loadPercentage += 1
        } else {
          clearInterval(processTimer)
        }
      }, 800)
      // 获取文件的下载地址
      try {
        const res = await this.$api.file.versionRecordsDownload(this.spaceId, this.openFileInfo.id)
        if (res && typeof res === 'string') {
          // 将下载地址传给插件，由插件进行下载
          await this.$desktopClient.DownloadFile(res, this.openFilePath, true)
          clearInterval(processTimer)
          this.loadPercentage = 100
          // 下载完成后，打开文件
          await this.openLocal()
        }
      } catch (err) {
        this.$matchError(err.code, downloadErrorCodeMap, '下载文件失败')
        await this.closeOpenDialog()
      }
    },
    // 打开本地缓存前需要先判断是否需要解压
    async openLocal() {
      if (this.zipFolderPath) {
        await this.openLocalFolder()
      } else {
        await this.openLocalFile()
      }
    },
    async openLocalFolder() {
      const { data: isFolderExist } = await this.$desktopClient.ExistDirectory(this.zipFolderPath)
      if (isFolderExist) {
        // 删除文件夹
        const { data: isDeleteOk } = await this.$desktopClient.DeleteDirectory(this.zipFolderPath, true)
        if (isDeleteOk) {
          await this.decompressOpenZip()
        }
      } else {
        await this.decompressOpenZip()
      }
    },
    async openLocalFile() {
      try {
        this.currentStep = 4
        const options = {
          userId: null,
          spaceId: this.spaceId,
          fileId: this.openFileInfo.id,
          fileType: this.openFileInfo.fileType,
          fileRevisionId: null,
          filePath: this.zipFolderPath || this.openFilePath,
          fileName: this.openFileInfo.name,
          fileSuffix: this.openFileInfo.suffix
        }
        await this.$desktopClient.OpenAndActivateDocument(options)
        await this.closeOpenDialog()
      } catch (err) {
        await this.closeOpenDialog()
      }
    },
    async closeOpenDialog() {
      // 关闭标题栏蒙层
      await this.$desktopClient.HideMask({ region: 'R_TITLE_BAR' })
      this.showOpenDialog = false
      this.currentStep = 1
      this.loadPercentage = 0
      this.openFileInfo = {}
      this.openFilePath = ''
    },
    handleSearch() {
      this.isFirstChange = true
      const activeLevel = this.getLevelFile(1)
      if (this.searchForm.keyword) {
        this.activeSearchName = activeLevel?.name || '全部文件'
      } else {
        this.activeSearchName = ''
      }
      this.search()
    },
    async handleRefresh() {
      await this.search()
      await this.getFolderData()
      this.$message.success('刷新成功')
    },
    async search(params) {
      // 获取当前层级
      const activeLevel = this.getLevelFile(1)
      activeLevel ? await this.getList({ parentId: activeLevel?.id, ...params }) : await this.refresh()
    },
    async getFolderData(params = {}) {
      await this.$api.file.getFilesList(this.spaceId, params).then((data) => {
        if (data) {
          this.folderData = data.list.filter((item) => item.isFolder)
          this.fileTreeList = Utils.listToTree(this.folderData, false, 'id')
          this.updateHighlightNode(this.selectFolderId || this.fileTreeList[0]?.id)
          this.activePermissionType = this.fileTreeList[0].permissionType
        }
      }).catch((err) => {
        this.$matchError(err.code, listErrorCodeMap)
      })
    },
    async getList(params = {}) {
      this.tableLoading = true
      const query = { ...this.searchForm, ...params }
      await this.$api.file.getFilesList(this.spaceId, query).then((data) => {
        if (data) {
          this.tableData = [...this.tableData, ...data.list.filter((item) => !this.tableData.find((existing) => existing.id === item.id))]
          this.selectTableData = data.list.filter((item) => {
            return item.isFolder || (this.softwareFileType.includes(item.fileType) && (!item.softwareCode || item.softwareCode === this.softwareCode))
          })
          this.tableData.forEach((item) => {
            const spaceCategoryObj = Utils.getPathByChild(
              this.spacePlatClassify,
              item.spaceCategoryId,
              null
            )
            // item.spaceCategoryIds = spaceCategoryObj.ids
            item.spaceCategoryNames = spaceCategoryObj.names
          })
          this.dataTotal = data.totalCount
        }
      }).catch((err) => {
        this.$matchError(err.code, listErrorCodeMap)
      }).finally(() => {
        this.tableLoading = false
      })
    },
    goToFolder(row) {
      this.selectFolderId = row.isFolder ? row.id : row.parentId
      this.updateHighlightNode(this.selectFolderId)
      this.getFilePath(row)
      this.quitSearchStatus()
      if (row.isFolder) {
        this.rowDblclick(row)
      }
    },
    // 更新高亮节点
    updateHighlightNode(id) {
      this.$nextTick(() => {
        this.$refs.classifyTree && this.$refs.classifyTree.highlightSomeNode(id)
        !this.defaultKeyArr.includes(this.fileTreeList[0]?.id) && this.defaultKeyArr.push(this.fileTreeList[0]?.id)
      })
    },
    async quitSearchStatus() {
      this.isFirstChange = true
      this.searchForm = {}
      this.activeSearchName = ''
      this.$refs.listTable?.$children[0].clearSort()
      this.search()
    },
    async updateAllData() {
      await this.getFolderData()
      await this.search()
    },
    async refresh() {
      this.filePaths = []
      this.tableData = []
      await this.getFolderData()
      await this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
.search-container {
  padding: 8px 0 8px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  >div:first-child {
    display: flex;
    align-items: center;
  }
  .logo-img {
    width: 18px;
    height: 21px;
    margin: 0 -16px 0 16px;
  }
}

.sizer-view-container {
  padding: 0 16px 16px;
  line-height: 40px;
  >span{
    color: @text-tag-gery;
    &:hover {
      cursor: pointer;
      color: @theme-color;
    }
  }
}

.flex-1 {
  height: calc(100vh - 90px);
}

.folder-catalog {
  max-height: calc(100vh - 100px);
}

.search-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 16px;
  .sizer-btn {
    margin-left: 10px;
  }
}

.sizer-btn-group {
  text-align: right;
  margin: 15px 0 0 0;
  display: flex;
  justify-content: space-between;
  >div:last-child {
    display: flex;
  }
}

.el-tag {
  background: @bg-grey-light-2;
  box-sizing: border-box;
  border: 1px solid @border-color-tag;
  color: @text-tag-gery;
  margin-right: 6px;
}

.sizer-content {
  display: flex;
  padding: 10px 0;
  .label-content {
    width: 50px;
  }
  .el-tag {
    margin-top: 8px;
  }
}

.sizer-box {
  position: relative;
  top: -8px;
  .el-tag {
    &:hover {
      cursor: pointer;
      background: @bg-grey-light-active-2;
      border-color: @border-color-active-tag;
      color: @text-tag-active-gery;
    }
  }
}

.active-tag {
  background: @bg-grey-light-active-2;
  border-color: @border-color-active-tag;
  color: @text-tag-active-gery;
}

/deep/.el-table__header {
  background-color: grey;
}

/deep/.el-dropdown {
  color: #009ee1;
}

.delete {
  color: red;
}

.delete:hover {
  color: #fff;
  background: red;
}

.el-dropdown-menu {
  width: 70px;
  // height: 112px;
  border-radius: 2px;
  padding: 4px 0;
  text-align: center;
}

.green {
  background: #fafafa;
  border: 1px solid #b7eb8f;
}

.grey {
  background: @bg-grey-light-2;
  border: 1px solid @border-color-tag;
}

.red {
  background: #fff1f0;
  border: 1px solid #ffa39e;
}

.el-tree {
  margin-left: 2px;
}

.keyword-input {
  width: 200px;
}

.btn-right {
  color: rgba(73, 95, 112, 0.6);
  font-size: 12px;
  margin-left: 10px;
}

.full-file-paths {
  cursor: pointer;
  color: @theme-color;
  width: 100%;
  display: inline-block;
}

.table-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .file-name{
    flex:1;
    min-height: 32px;
  }
  .file-btn{
    flex: 0 0 80px;
  }
  img {
    position: relative;
    top: 5px;
  }
}
.folder-img, .file-img {
  width: 20px;
  height: 20px;
}
.tip-container{
  text-align: center;
  color: #495F70;
  .line-1{
    margin-bottom: 8px;
  }
  .line-3{
    margin: 8px 0;
  }
  .line-4{
    height: 80px;
    line-height: 80px;
    background: #F7F9FA;
  }
}
.confirm-container{
  padding: 10px 0;
  .confirm-text{
    padding: 10px 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .confirm-btn{
    text-align: right;
  }
}
.loading-img{
  animation: rotate 2s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/deep/ .right-part {
  width: 1px;
  height: calc(100vh - 112px);
}

/deep/ .el-table .el-table__body-wrapper {
  max-height: calc(100% - 51px);
}

/deep/ .el-table__row {
  cursor: pointer;
}

/deep/ .el-breadcrumb {
  display: flex;
  align-items: baseline;
  .return-to-upper-level {
    cursor: pointer;
    color: @color-text-breadcrumb;
    &:hover {
      color: @color-text-breadcrumb-hover;
    }
  }
  i {
    margin-right: 2px;
  }
  .el-breadcrumb__item:last-child {
    >span {
      color: @color-text-breadcrumb-hover;
    }
  }
}
</style>
